export default __webpack_public_path__ + "static/media/KC-website.b37b19c4.png";